import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteMedia, fetchVideos } from "../../features/admin/MediaSlice";
import { toast } from "react-toastify";
import { PlayCircleIcon } from "@heroicons/react/16/solid";
import VideoModal from "../../components/admin/VideoModal";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const Video = () => {
  const dispatch = useDispatch();
  const { medias, status, error } = useSelector((state) => state.medias);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const handleOpenModal = (media = null) => {
    setSelectedMedia(media);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMedia(null);
  };

  const handleDelete = (id) => {
    dispatch(deleteMedia(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Xóa video thành công!");
        handleCloseModal();
      } else {
        toast.error("Đã xảy ra lỗi khi xóa video!");
      }
    });
  };
  useEffect(() => {
    dispatch(fetchVideos());
  }, []);
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchVideos());
    }
  }, [status, dispatch]);
  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p>Error: {error}</p>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Quản lý video</h1>
      {hasPermission("MEDIA_UPLOAD") && (
        <button
          onClick={() => handleOpenModal()}
          className="btn btn-success transition-colors px-4 py-2 rounded mb-4"
        >
          + Thêm video
        </button>
      )}
      <div>
        {!medias || medias.length === 0 ? (
          <div className="alert alert-info shadow-lg">
            <div>
              <span>Không có video nào được tìm thấy.</span>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {medias.map((video, index) => (
              <div
                key={index}
                className="card bg-base-100 shadow-xl hover:shadow-2xl transition-all"
              >
                <figure
                  className="relative aspect-video cursor-pointer group"
                  onClick={() => handleOpenModal(video)}
                >
                  <iframe
                    src={video?.url?.replace("watch?v=", "embed/")}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  ></iframe>
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all">
                    <PlayCircleIcon className="w-12 h-12 text-white" />
                  </div>
                </figure>
                <div className="card-body">
                  <h2 className="card-title line-clamp-2">{video.title}</h2>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {isModalOpen && (
        <VideoModal
          media={selectedMedia}
          onClose={handleCloseModal}
          onDelete={() => handleDelete(selectedMedia?.id)}
        />
      )}
    </div>
  );
};

export default Video;
